import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { apiService } from '../api/api';
import './Common.css';
import { Check } from 'lucide-react';

// ─── International Phone Validation ──────────────────────────────────────────
const COUNTRY_PHONE_RULES = [
  { code: '+1', iso: 'US', name: 'USA / Canada', maxLen: 12, pattern: /^\+1[2-9]\d{2}[2-9]\d{6}$/, digits: '10 digits after +1', example: '+12025551234' },
  { code: '+91', iso: 'IN', name: 'India', maxLen: 13, pattern: /^\+91[6-9]\d{9}$/, digits: '10 digits after +91', example: '+919876543210' },
  { code: '+86', iso: 'CN', name: 'China', maxLen: 14, pattern: /^\+86(13|14|15|16|17|18|19)\d{9}$/, digits: '11 digits after +86', example: '+8613812345678' },
  { code: '+81', iso: 'JP', name: 'Japan', maxLen: 13, pattern: /^\+81[789]0\d{8}$/, digits: '10-11 digits after +81', example: '+819012345678' },
  { code: '+82', iso: 'KR', name: 'South Korea', maxLen: 13, pattern: /^\+821[0-9]\d{7,8}$/, digits: '9-10 digits after +82', example: '+821012345678' },
  { code: '+65', iso: 'SG', name: 'Singapore', maxLen: 11, pattern: /^\+65[689]\d{7}$/, digits: '8 digits after +65', example: '+6591234567' },
  { code: '+60', iso: 'MY', name: 'Malaysia', maxLen: 13, pattern: /^\+601[0-9]\d{7,8}$/, digits: '9-10 digits after +60', example: '+60123456789' },
  { code: '+66', iso: 'TH', name: 'Thailand', maxLen: 12, pattern: /^\+66[689]\d{8}$/, digits: '9 digits after +66', example: '+66812345678' },
  { code: '+63', iso: 'PH', name: 'Philippines', maxLen: 13, pattern: /^\+639\d{9}$/, digits: '10 digits after +63', example: '+639171234567' },
  { code: '+62', iso: 'ID', name: 'Indonesia', maxLen: 15, pattern: /^\+628\d{8,11}$/, digits: '9-12 digits after +62', example: '+62812345678' },
  { code: '+92', iso: 'PK', name: 'Pakistan', maxLen: 13, pattern: /^\+923\d{9}$/, digits: '10 digits after +92', example: '+923001234567' },
  { code: '+880', iso: 'BD', name: 'Bangladesh', maxLen: 14, pattern: /^\+8801[3-9]\d{8}$/, digits: '10 digits after +880', example: '+8801712345678' },
  { code: '+971', iso: 'AE', name: 'UAE', maxLen: 13, pattern: /^\+9715\d{8}$/, digits: '9 digits after +971', example: '+971501234567' },
  { code: '+966', iso: 'SA', name: 'Saudi Arabia', maxLen: 13, pattern: /^\+9665\d{8}$/, digits: '9 digits after +966', example: '+966512345678' },
  { code: '+974', iso: 'QA', name: 'Qatar', maxLen: 12, pattern: /^\+974[3-7]\d{7}$/, digits: '8 digits after +974', example: '+97430123456' },
  { code: '+973', iso: 'BH', name: 'Bahrain', maxLen: 12, pattern: /^\+973[3-9]\d{7}$/, digits: '8 digits after +973', example: '+97333123456' },
  { code: '+968', iso: 'OM', name: 'Oman', maxLen: 12, pattern: /^\+9689\d{7}$/, digits: '8 digits after +968', example: '+96891234567' },
  { code: '+972', iso: 'IL', name: 'Israel', maxLen: 13, pattern: /^\+9725\d{8}$/, digits: '9 digits after +972', example: '+972501234567' },
  { code: '+44', iso: 'GB', name: 'UK', maxLen: 13, pattern: /^\+447\d{9}$/, digits: '10 digits after +44', example: '+447911123456' },
  { code: '+49', iso: 'DE', name: 'Germany', maxLen: 15, pattern: /^\+491[567]\d{8,10}$/, digits: '10-12 digits after +49', example: '+4915123456789' },
  { code: '+33', iso: 'FR', name: 'France', maxLen: 12, pattern: /^\+33[67]\d{8}$/, digits: '9 digits after +33', example: '+33612345678' },
  { code: '+39', iso: 'IT', name: 'Italy', maxLen: 13, pattern: /^\+393\d{9}$/, digits: '10 digits after +39', example: '+393123456789' },
  { code: '+34', iso: 'ES', name: 'Spain', maxLen: 12, pattern: /^\+346\d{8}$/, digits: '9 digits after +34', example: '+34612345678' },
  { code: '+31', iso: 'NL', name: 'Netherlands', maxLen: 12, pattern: /^\+316\d{8}$/, digits: '9 digits after +31', example: '+31612345678' },
  { code: '+41', iso: 'CH', name: 'Switzerland', maxLen: 12, pattern: /^\+417[6-9]\d{7}$/, digits: '9 digits after +41', example: '+41761234567' },
  { code: '+43', iso: 'AT', name: 'Austria', maxLen: 14, pattern: /^\+436\d{8,10}$/, digits: '9-11 digits after +43', example: '+436641234567' },
  { code: '+32', iso: 'BE', name: 'Belgium', maxLen: 12, pattern: /^\+324\d{8}$/, digits: '9 digits after +32', example: '+32412345678' },
  { code: '+47', iso: 'NO', name: 'Norway', maxLen: 11, pattern: /^\+474\d{7}$/, digits: '8 digits after +47', example: '+4741234567' },
  { code: '+46', iso: 'SE', name: 'Sweden', maxLen: 12, pattern: /^\+467\d{8}$/, digits: '9 digits after +46', example: '+46701234567' },
  { code: '+45', iso: 'DK', name: 'Denmark', maxLen: 11, pattern: /^\+454\d{7}$/, digits: '8 digits after +45', example: '+4541234567' },
  { code: '+358', iso: 'FI', name: 'Finland', maxLen: 14, pattern: /^\+3584\d{7,8}$/, digits: '8-9 digits after +358', example: '+358412345678' },
  { code: '+48', iso: 'PL', name: 'Poland', maxLen: 12, pattern: /^\+48[4-9]\d{8}$/, digits: '9 digits after +48', example: '+48512345678' },
  { code: '+7', iso: 'RU', name: 'Russia', maxLen: 12, pattern: /^\+7[789]\d{9}$/, digits: '10 digits after +7', example: '+79161234567' },
  { code: '+380', iso: 'UA', name: 'Ukraine', maxLen: 13, pattern: /^\+380[3-9]\d{8}$/, digits: '9 digits after +380', example: '+380501234567' },
  { code: '+30', iso: 'GR', name: 'Greece', maxLen: 13, pattern: /^\+306\d{9}$/, digits: '10 digits after +30', example: '+306901234567' },
  { code: '+351', iso: 'PT', name: 'Portugal', maxLen: 13, pattern: /^\+3519\d{8}$/, digits: '9 digits after +351', example: '+351912345678' },
  { code: '+36', iso: 'HU', name: 'Hungary', maxLen: 13, pattern: /^\+36[237]\d{7,8}$/, digits: '8-9 digits after +36', example: '+36201234567' },
  { code: '+420', iso: 'CZ', name: 'Czech Republic', maxLen: 13, pattern: /^\+420[6-7]\d{8}$/, digits: '9 digits after +420', example: '+420601234567' },
  { code: '+40', iso: 'RO', name: 'Romania', maxLen: 12, pattern: /^\+407\d{8}$/, digits: '9 digits after +40', example: '+40712345678' },
  { code: '+55', iso: 'BR', name: 'Brazil', maxLen: 14, pattern: /^\+55[1-9][1-9]\d{8,9}$/, digits: '10-11 digits after +55', example: '+5511912345678' },
  { code: '+52', iso: 'MX', name: 'Mexico', maxLen: 14, pattern: /^\+521\d{10}$/, digits: '10 digits after +52', example: '+5215512345678' },
  { code: '+54', iso: 'AR', name: 'Argentina', maxLen: 14, pattern: /^\+549\d{10}$/, digits: '10 digits after +54', example: '+5491112345678' },
  { code: '+56', iso: 'CL', name: 'Chile', maxLen: 12, pattern: /^\+569\d{8}$/, digits: '9 digits after +56', example: '+56912345678' },
  { code: '+57', iso: 'CO', name: 'Colombia', maxLen: 13, pattern: /^\+573\d{9}$/, digits: '10 digits after +57', example: '+573001234567' },
  { code: '+27', iso: 'ZA', name: 'South Africa', maxLen: 12, pattern: /^\+276\d{8}$/, digits: '9 digits after +27', example: '+27612345678' },
  { code: '+234', iso: 'NG', name: 'Nigeria', maxLen: 14, pattern: /^\+2347\d{9}$/, digits: '10 digits after +234', example: '+2347012345678' },
  { code: '+20', iso: 'EG', name: 'Egypt', maxLen: 13, pattern: /^\+201[0125]\d{8}$/, digits: '10 digits after +20', example: '+201012345678' },
  { code: '+254', iso: 'KE', name: 'Kenya', maxLen: 13, pattern: /^\+2547\d{8}$/, digits: '9 digits after +254', example: '+254712345678' },
  { code: '+61', iso: 'AU', name: 'Australia', maxLen: 12, pattern: /^\+614\d{8}$/, digits: '9 digits after +61', example: '+61412345678' },
  { code: '+64', iso: 'NZ', name: 'New Zealand', maxLen: 13, pattern: /^\+642\d{7,9}$/, digits: '8-10 digits after +64', example: '+6421234567' },
];

const detectCountryRule = (phone) => {
  if (!phone || !phone.startsWith('+')) return null;
  const sorted = [...COUNTRY_PHONE_RULES].sort((a, b) => b.code.length - a.code.length);
  return sorted.find(r => phone.startsWith(r.code)) || null;
};

const validatePhoneNumber = (phone) => {
  if (!phone || !phone.trim()) return { valid: false, message: 'Phone number is required' };
  const cleaned = phone.replace(/[\s\-().]/g, '');
  if (!cleaned.startsWith('+')) {
    return { valid: false, message: 'Phone must start with a country code (e.g. +1 for USA, +91 for India)' };
  }
  const rule = detectCountryRule(cleaned);
  if (!rule) {
    const genericPattern = /^\+\d{1,4}\d{6,12}$/;
    if (!genericPattern.test(cleaned)) {
      return { valid: false, message: 'Invalid phone number. Use format: +[country code][number] (e.g. +12025551234)' };
    }
    return { valid: true, message: '', country: null };
  }
  if (!rule.pattern.test(cleaned)) {
    return { valid: false, message: `Invalid ${rule.name} number. Format: ${rule.digits} (e.g. ${rule.example})`, country: rule };
  }
  return { valid: true, message: '', country: rule };
};

// ─── Smart Phone Input Component ─────────────────────────────────────────────
const SmartPhoneInput = ({
  value = '',
  onChange,
  onBlur,
  error,
  name = 'phoneNumber',
  placeholder,
}) => {
  const cleaned = value.replace(/[\s\-().]/g, '');
  const detected = detectCountryRule(cleaned);

  const digitsTyped = cleaned.replace(/^\+/, '').replace(/\D/g, '').length;
  const maxCleanLen = detected ? detected.maxLen : null;
  const maxDigits = maxCleanLen ? maxCleanLen - 1 : null;
  const isAtMax = maxDigits !== null && digitsTyped >= maxDigits;
  const isOverMax = maxDigits !== null && digitsTyped > maxDigits;
  const isValidNow = detected && validatePhoneNumber(value).valid;

  const borderColor = error
    ? '#ea4335'
    : isOverMax
      ? '#ea4335'
      : isValidNow
        ? '#16a34a'
        : '#ced4da';

  const ALLOWED = /^[+\d\s\-().]*$/;

  const emit = (newVal) => {
    onChange({ target: { name, value: newVal } });
  };

  const handleKeyDown = (e) => {
    if (
      ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End']
        .includes(e.key) || e.ctrlKey || e.metaKey
    ) return;

    if (e.key === '+') {
      if (e.target.selectionStart !== 0 || value.includes('+')) {
        e.preventDefault(); return;
      }
    }

    if (!/[\d\s\-().]/.test(e.key) && e.key !== '+') {
      e.preventDefault(); return;
    }

    if (/\d/.test(e.key) && maxDigits !== null) {
      const selectedDigits = value
        .slice(e.target.selectionStart, e.target.selectionEnd)
        .replace(/\D/g, '').length;
      const netNewDigits = 1 - selectedDigits;
      if (digitsTyped + netNewDigits > maxDigits) {
        e.preventDefault(); return;
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    let pasted = e.clipboardData.getData('text').replace(/[^+\d\s\-().]/g, '');
    const hasPlus = pasted.includes('+');
    pasted = pasted.replace(/\+/g, '');
    if (hasPlus) pasted = '+' + pasted;

    const { selectionStart: s, selectionEnd: en } = e.target;
    let newVal = value.slice(0, s) + pasted + value.slice(en);

    const newCleaned = newVal.replace(/[\s\-().]/g, '');
    const rule = detectCountryRule(newCleaned);
    if (rule) newVal = newCleaned.slice(0, rule.maxLen);

    emit(newVal);
  };

  const handleChange = (e) => {
    let val = e.target.value;
    if (!ALLOWED.test(val)) val = val.replace(/[^+\d\s\-().]/g, '');
    if (val.indexOf('+') > 0 || (val.split('+').length - 1) > 1) {
      val = '+' + val.replace(/\+/g, '');
    }
    const valCleaned = val.replace(/[\s\-().]/g, '');
    const rule = detectCountryRule(valCleaned);
    if (rule && valCleaned.length > rule.maxLen) val = valCleaned.slice(0, rule.maxLen);
    emit(val);
  };

  const counterText = maxDigits !== null ? `${digitsTyped} / ${maxDigits}` : null;
  const counterColor = isOverMax ? '#ea4335' : isAtMax && isValidNow ? '#16a34a' : '#9ca3af';

  return (
    <div>
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {detected && (
          <div style={{
            position: 'absolute', left: 0, top: 0, bottom: 0,
            display: 'flex', alignItems: 'center', gap: 4,
            padding: '0 10px',
            background: '#f1f5f9',
            borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px',
            borderRight: `1.5px solid ${borderColor}`,
            pointerEvents: 'none', zIndex: 2, whiteSpace: 'nowrap',
            minWidth: 58,
          }}>
            <span style={{ fontSize: 16, lineHeight: 1 }}>{detected.flag}</span>
            <span style={{ fontSize: 12, fontWeight: 700, color: '#475569', letterSpacing: '0.5px' }}>
              {detected.iso}
            </span>
          </div>
        )}

        <input
          type="tel"
          name={name}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          onBlur={onBlur}
          placeholder={placeholder || '+1 202 555 1234  ·  +91 98765 43210  ·  +44 7911 123456'}
          className="form-control contact-input"
          style={{
            paddingLeft: detected ? '74px' : '14px',
            paddingRight: counterText ? '64px' : '14px',
            border: `1.5px solid ${borderColor}`,
            borderRadius: '6px',
            fontSize: '14px',
            boxShadow: 'none',
            transition: 'border-color 0.2s',
          }}
          onFocus={e => { e.target.style.borderColor = error ? '#ea4335' : '#018d71'; }}
          onBlur2={e => { e.target.style.borderColor = borderColor; }}
        />

        {counterText && (
          <span style={{
            position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
            fontSize: 11, fontWeight: 700, color: counterColor,
            pointerEvents: 'none', userSelect: 'none',
          }}>
            {counterText}
          </span>
        )}
      </div>

      {/* Status row */}
      {(() => {
        if (detected && isValidNow && !error)
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 5, fontSize: 11, color: '#16a34a', fontWeight: 600 }}>
              <Check size={11} /> {detected.flag} {detected.name} · Valid number
            </div>
          );
        if (detected && isOverMax)
          return (
            <div style={{ marginTop: 5, fontSize: 11, color: '#ea4335', fontWeight: 600 }}>
              ⚠️ Too many digits for {detected.name} ({detected.digits})
            </div>
          );
        if (detected && !isValidNow && !error && value.length > detected.code.length)
          return (
            <div style={{ marginTop: 5, fontSize: 11, color: '#6b7280' }}>
              {detected.flag} {detected.name} · {detected.digits} · e.g. {detected.example}
            </div>
          );
        if (!detected && value && value.startsWith('+') && !error)
          return (
            <div style={{ marginTop: 5, fontSize: 11, color: '#6b7280' }}>
              🌍 Examples: +12025551234 (USA) · +919876543210 (India) · +447911123456 (UK)
            </div>
          );
        if (!value)
          return (
            <div style={{ marginTop: 5, fontSize: 11, color: '#9ca3af' }}>
              Start with country code · +1 (USA) · +91 (India) · +44 (UK)
            </div>
          );
        return null;
      })()}

      {error && (
        <div style={{ fontSize: '12px', color: '#ea4335', marginTop: '5px', fontWeight: 500 }}>
          ⚠️ {error}
        </div>
      )}
    </div>
  );
};

// ─── Contact Component ────────────────────────────────────────────────────────
// ✅ FIX: Accept onNavigate prop so Privacy Policy and Terms links work correctly
const Contact = ({ onNavigate }) => {
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    email: '',
    subject: '',
    message: '',
    agreeToTerms: false,
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  // ── Field change handler ───────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    // Clear error on change
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  // ── Validate all fields ────────────────────────────────────────────────────
  const validate = () => {
    const e = {};

    if (!formData.name.trim()) {
      e.name = 'Name is required';
    } else if (formData.name.trim().length < 2) {
      e.name = 'Name must be at least 2 characters';
    }

    if (!formData.phoneNumber.trim()) {
      e.phoneNumber = 'Phone number is required';
    } else {
      const result = validatePhoneNumber(formData.phoneNumber.trim());
      if (!result.valid) e.phoneNumber = result.message;
    }

    if (!formData.email.trim()) {
      e.email = 'Email address is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      e.email = 'Please enter a valid email address (e.g. name@example.com)';
    }

    if (!formData.subject.trim()) {
      e.subject = 'Subject is required';
    }

    if (!formData.agreeToTerms) {
      e.agreeToTerms = 'You must agree to the terms to submit';
    }

    return e;
  };

  // ── Submit ─────────────────────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setSubmitting(true);
      await apiService.sendContactForm(formData);
      alert('Message sent successfully!');
      setFormData({ name: '', phoneNumber: '', email: '', subject: '', message: '', agreeToTerms: false });
      setErrors({});
    } catch (error) {
      const msg = error.response?.data?.message || 'Something went wrong. Please try again.';
      alert(msg);
    } finally {
      setSubmitting(false);
    }
  };

  // ── Internal nav helper ────────────────────────────────────────────────────
  // ✅ FIX: Handles clicks on Privacy Policy / Terms links inside the form
  const handleInternalNav = (page) => (e) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate(page);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // ── Shared error message element ───────────────────────────────────────────
  const ErrMsg = ({ field }) =>
    errors[field] ? (
      <div style={{ fontSize: '12px', color: '#ea4335', marginTop: '5px', fontWeight: 500 }}>
        ⚠️ {errors[field]}
      </div>
    ) : null;

  return (
    <div className="contact-page">

      {/* Header Section */}
      <section className="contact-header-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="contact-main-title">Contact</h1>
              <p className="contact-subtitle">
                We're here to help with your healthcare supply needs. Have questions or need a quote? Reach out to us anytime.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="container">
          <div className="row">

            {/* Left Side - Contact Info */}
            <div className="col-lg-5 mb-5 mb-lg-0">
              <span className="form-label-small">DETAILS</span>
              <h2 className="contact-form-title">Contact Information</h2>
              <p className="contact-form-text">
                We're here to assist you with all your healthcare supply needs. Whether you have questions about our products, need a quote, or require any other support.
              </p>

              <div className="contact-cards-grid">
                <div className="contact-info-card-new">
                  <div className="contact-icon-new">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#02A686" />
                    </svg>
                  </div>
                  <h4 className="contact-card-title">Office Location</h4>
                  <p className="contact-card-detail">11 Elkins Rd East Brunswick, NJ 08816</p>
                </div>

                <div className="contact-info-card-new">
                  <div className="contact-icon-new">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="#02A686" />
                    </svg>
                  </div>
                  <h4 className="contact-card-title">Phone</h4>
                  <p className="contact-card-detail">Call : 732 651 8800</p>
                  <p className="contact-card-detail">Fax : 732 651 8801</p>
                </div>

                <div className="contact-info-card-new contact-info-card-full">
                  <div className="contact-icon-new">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="#02A686" />
                    </svg>
                  </div>
                  <h4 className="contact-card-title">Company Mail</h4>
                  <p className="contact-card-detail">orthomedproducts@gmail.com</p>
                </div>
              </div>
            </div>

            {/* Right Side - Form */}
            <div className="col-lg-7">
              <form onSubmit={handleSubmit} className="contact-form" noValidate>

                {/* Name */}
                <div className="mb-4">
                  <label className="form-label">
                    Your Name <span style={{ color: '#ea4335' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className={`form-control contact-input ${errors.name ? 'is-invalid' : ''}`}
                    style={{ border: `1.5px solid ${errors.name ? '#ea4335' : '#ced4da'}` }}
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="John Doe"
                  />
                  <ErrMsg field="name" />
                </div>

                {/* Phone Number */}
                <div className="mb-4">
                  <label className="form-label">
                    Your Phone Number <span style={{ color: '#ea4335' }}>*</span>
                  </label>
                  <SmartPhoneInput
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    onBlur={() => {
                      if (formData.phoneNumber.trim()) {
                        const result = validatePhoneNumber(formData.phoneNumber.trim());
                        if (!result.valid) setErrors(prev => ({ ...prev, phoneNumber: result.message }));
                        else setErrors(prev => ({ ...prev, phoneNumber: '' }));
                      }
                    }}
                    error={errors.phoneNumber}
                    name="phoneNumber"
                  />
                </div>

                {/* Email */}
                <div className="mb-4">
                  <label className="form-label">
                    Your Email <span style={{ color: '#ea4335' }}>*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="form-control contact-input"
                    style={{ border: `1.5px solid ${errors.email ? '#ea4335' : '#ced4da'}`, boxShadow: 'none' }}
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="name@example.com"
                    onFocus={e => { e.target.style.borderColor = errors.email ? '#ea4335' : '#018d71'; }}
                    onBlur={e => {
                      e.target.style.borderColor = errors.email ? '#ea4335' : '#ced4da';
                      if (formData.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
                        setErrors(prev => ({ ...prev, email: 'Please enter a valid email address (e.g. name@example.com)' }));
                      }
                    }}
                  />
                  {errors.email ? (
                    <div style={{ fontSize: '12px', color: '#ea4335', marginTop: '5px', fontWeight: 500 }}>
                      ⚠️ {errors.email}
                    </div>
                  ) : formData.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 5, fontSize: 11, color: '#16a34a', fontWeight: 600 }}>
                      <Check size={11} /> Valid email address
                    </div>
                  ) : null}
                </div>

                {/* Subject */}
                <div className="mb-4">
                  <label className="form-label">
                    Subject <span style={{ color: '#ea4335' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="subject"
                    className="form-control contact-input"
                    style={{ border: `1.5px solid ${errors.subject ? '#ea4335' : '#ced4da'}`, boxShadow: 'none' }}
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="How can we help you?"
                    onFocus={e => { e.target.style.borderColor = errors.subject ? '#ea4335' : '#018d71'; }}
                    onBlur={e => { e.target.style.borderColor = errors.subject ? '#ea4335' : '#ced4da'; }}
                  />
                  <ErrMsg field="subject" />
                </div>

                {/* Message */}
                <div className="mb-4">
                  <label className="form-label">Your Message (optional)</label>
                  <textarea
                    name="message"
                    className="form-control contact-textarea"
                    style={{ boxShadow: 'none' }}
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Write your message here..."
                    onFocus={e => { e.target.style.borderColor = '#018d71'; }}
                    onBlur={e => { e.target.style.borderColor = '#ced4da'; }}
                  />
                </div>

                {/* Terms Checkbox */}
                <div className="mb-4">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="agreeTerms"
                      name="agreeToTerms"
                      checked={formData.agreeToTerms}
                      onChange={handleChange}
                      style={{ borderColor: errors.agreeToTerms ? '#ea4335' : undefined }}
                    />
                    <label className="form-check-label" htmlFor="agreeTerms">
                      By checking this box, I consent to receive Conversational SMS from Ortho Med Products.
                      Reply STOP to opt-out; Reply HELP for support; Message & data rates may apply;
                      Messaging frequency may vary. Visit to view our{' '}
                      {/* ✅ FIX: Uses onNavigate instead of href routing */}
                      <a
                        href="#privacy"
                        className="terms-link"
                        onClick={handleInternalNav('privacy')}
                      >
                        Privacy Policy
                      </a>{' '}and for our{' '}
                      <a
                        href="#terms"
                        className="terms-link"
                        onClick={handleInternalNav('terms')}
                      >
                        Terms of Condition
                      </a>.
                    </label>
                  </div>
                  <ErrMsg field="agreeToTerms" />
                </div>

                <button
                  type="submit"
                  className="btn-submit-contact"
                  disabled={submitting}
                  style={{ opacity: submitting ? 0.7 : 1, cursor: submitting ? 'not-allowed' : 'pointer' }}
                >
                  {submitting ? 'SENDING...' : 'SUBMIT'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="container-fluid p-0">
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.2412648750455!2d-73.98784368459395!3d40.74844097932847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9b3117469%3A0xd134e199a405a163!2sEmpire%20State%20Building!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Office Location Map"
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-box">
            <div className="row align-items-center">
              <div className="col-lg-8 mb-3 mb-lg-0">
                <h3 className="cta-title">Contact us today to learn more about our products.</h3>
              </div>
              <div className="col-lg-4 text-lg-end">
                {/* <button className="btn-cta">Contact Us Now</button>/ */}
                {/* issue number :- Ecommerce_081 /////// */}
                <button
                  className="btn-cta"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  Contact Us Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;